import { Card, Image, Modal, Tooltip } from 'antd';
import React, { useState } from 'react';
import { ReactComponent as IconGSMActive } from '../assets/icons/icon-gsm-active.svg';
import { ReactComponent as IconGSMInActive } from '../assets/icons/icon-gsm-inactive.svg';
import { ReactComponent as IconSatelliteActive } from '../assets/icons/icon-satellite-active.svg';
import { ReactComponent as IconSatelliteInActive } from '../assets/icons/icon-satellite-inactive.svg';
import { ReactComponent as IconInfo } from '../assets/icons/icon-info.svg';
import { ReactComponent as IconFMSApp } from '../assets/icons/icon-app-fms.svg';
import { ReactComponent as IconAM } from '../assets/icons/icon-app-am.svg';
import { ReactComponent as IconTLM } from '../assets/icons/icon-app-tlm.svg';
import { ReactComponent as IconBM } from '../assets/icons/icon-app-bm.svg';
import IconAsset from '../assets/icons/icon-asset.svg';
import IconBunkering from '../assets/icons/icon-bunkering.svg';
import IconFMS from '../assets/icons/icon-fms.svg';
import IconTankLevel from '../assets/icons/icon-tank-level.svg';
import { DownOutlined } from '@ant-design/icons';
import useGroup from '../zustand/useGroup';
import useMapSetting from '../zustand/useMap';
import { AssetProperties } from '../screens/asset/types/asset.type';

const ActionApplication = () => {
  const { company, feature, setFeature } = useGroup();
  const { dataSource, setDataSource } = useMapSetting();
  const [isModalSelectApp, setIsModalSelectApp] = useState<boolean>(false);
  const [selectedFeature, setSelectedFeature] = useState<string>(feature);

  const hasGSM = company?.assets?.some(
    (asset: AssetProperties) => !asset.satelliteId && !asset.satelliteDeviceId && !asset.satelliteOperator
  );
  const hasSatellite = company?.assets?.some(
    (asset: AssetProperties) => asset.satelliteId || asset.satelliteDeviceId || asset.satelliteOperator
  );
  const canToggle = hasGSM && hasSatellite; 

  const _renderSetFeature = (icon: any, title: string, description: string) => {
    let isActive = false;

    switch (title) {
      case 'Fuel Monitoring System':
        isActive = company?.isFms ? company?.isFms : false;
        break;
      case 'Asset Monitoring':
        // isActive = company?.isAm ? company?.isAm : false;
        isActive = false;
        break;
      case 'Bunkering Monitoring':
        isActive = company?.isBm ? company?.isBm : false;
        // isActive = false;
        break;
      case 'Tank Level Monitoring':
        // isActive = company?.isTlm ? company?.isTlm : false;
        isActive = false;
        break;
    }

    return (
      <Card
        style={{
          height: 200,
          cursor: isActive ? 'pointer' : 'not-allowed',
          border:
            title === selectedFeature
              ? `2px solid #264284`
              : '1px solid var(--gray-3)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: 10,
          paddingBottom: 10,
          backgroundColor: isActive ? 'transparent' : 'var(--gray-2)',
        }}
        bordered
        onClick={() => {
          if (isActive) setSelectedFeature(title);
        }}
      >
        <div
          style={{
            opacity: isActive ? 1 : 0.4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <Image
            src={icon}
            alt='FMS Icon'
            width={76}
            height={76}
            style={{ objectFit: 'contain' }}
            preview={false}
          />
          <div style={{ fontWeight: 'bold', marginTop: 10 }}>{title}</div>
          <div style={{ fontSize: 10, marginTop: 5 }}>{description}</div>
        </div>
      </Card>
    );
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
        {/*
        <div
          style={{
            marginTop: 12,
            cursor: 'pointer',
          }}
        >
          <Tooltip title='Choose data source. You can switch data source of this page between Satellite or GSM'>
            <IconInfo />
          </Tooltip>
        </div>
        <div
          style={{
            backgroundColor: '#D2D8E1',
            borderRadius: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: 2,
            height: 35,
            gap: 5,
            marginRight: -10,
            opacity: canToggle ? 1 : 0.5,
            cursor: canToggle ? 'pointer' : 'not-allowed',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 5,
              cursor: canToggle && hasGSM ? 'pointer' : 'not-allowed',
              backgroundColor:
                dataSource === 'GSM' ? 'var(--primary-2)' : 'transparent',
              color: dataSource === 'GSM' ? 'white' : 'black',
              height: 30,
              borderRadius: 20,
              paddingLeft: 10,
              paddingRight: 10,
              opacity: hasGSM ? 1 : 0.4,
            }}
            onClick={() => canToggle && hasGSM && setDataSource('GSM')}
          >
            {dataSource === 'GSM' ? <IconGSMActive /> : <IconGSMInActive />}
            GSM
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 5,
              cursor: canToggle && hasSatellite ? 'pointer' : 'not-allowed',
              backgroundColor:
                dataSource === 'SATELLITE' ? '#FF842C' : 'transparent',
              color: dataSource === 'SATELLITE' ? 'white' : 'black',
              height: 30,
              borderRadius: 20,
              paddingLeft: 10,
              paddingRight: 10,
              opacity: hasSatellite ? 1 : 0.4,
            }}
            onClick={() => canToggle && hasSatellite && setDataSource('SATELLITE')}
          >
            {dataSource === 'SATELLITE' ? (
              <IconSatelliteActive />
            ) : (
              <IconSatelliteInActive />
            )}
            Satellite
          </div>
        </div>
        <div
          style={{
            background: 'rgba(0, 0, 0, 0.05)',
            height: 40,
            width: 1,
          }}
        />
        */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            gap: 5,
            marginLeft: 10,
            marginRight: 10,
          }}
          onClick={() => {
            setIsModalSelectApp(true);
          }}
        >
          {feature === 'Fuel Monitoring System' && <IconFMSApp />}
          {feature === 'Asset Monitoring' && <IconAM />}
          {feature === 'Bunkering Monitoring' && <IconBM />}
          {feature === 'Tank Level Monitoring' && <IconTLM />}
          {feature}
          <DownOutlined />
        </div>
      </div>

      <Modal
        open={isModalSelectApp}
        okText='Confirm Selection'
        onOk={() => {
          setFeature(selectedFeature);
          setIsModalSelectApp(false);
        }}
        onCancel={() => setIsModalSelectApp(false)}
        width={'45%'}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            padding: '15px 25px 15px 25px',
            backgroundColor: 'rgb(232, 236, 243)',
            height: 75,
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            textAlign: 'center',
          }}
        >
          <div style={{ fontWeight: 'bold', fontSize: 16 }}>
            Select Application
          </div>
          <div style={{ color: '#768499' }}>
            Select application that you want to use
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 20,
            flexWrap: 'wrap',
            paddingTop: 20,
            marginTop: 50,
            marginBottom: 20,
          }}
        >
          {_renderSetFeature(
            IconFMS,
            'Fuel Monitoring System',
            'Select Group and Company that you want to trace'
          )}
          {_renderSetFeature(
            IconAsset,
            'Asset Monitoring',
            'Select Group and Company that you want to trace'
          )}
          {_renderSetFeature(
            IconBunkering,
            'Bunkering Monitoring',
            'Select Group and Company that you want to trace'
          )}
          {_renderSetFeature(
            IconTankLevel,
            'Tank Level Monitoring',
            'Select Group and Company that you want to trace'
          )}
        </div>
      </Modal>
    </>
  );
};

export default ActionApplication;
